import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/apps/terminal/app/ningenie/components/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConvexClientProvider"] */ "/vercel/path0/apps/terminal/app/ningenie/components/ConvexClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PWAInstallPrompt"] */ "/vercel/path0/apps/terminal/app/ningenie/components/PWAInstallPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PWAMetaTags"] */ "/vercel/path0/apps/terminal/app/ningenie/components/PWAMetaTags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PWAServiceWorkerRegister"] */ "/vercel/path0/apps/terminal/app/ningenie/components/PWAServiceWorkerRegister.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeInitializer"] */ "/vercel/path0/apps/terminal/app/ningenie/components/ThemeInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WakeLockProvider"] */ "/vercel/path0/apps/terminal/app/ningenie/components/WakeLockProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/apps/terminal/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/vercel/path0/apps/terminal/components/ui/use-toast.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/katex@0.16.39/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.9_@babel+core@7.29.7_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@1.0_447eec3240ddf9bc9d0824f94b68d795/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/streamdown@2.5.0_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/streamdown/styles.css");
